export const acceptedFiles = {
  'application/pdf': ['.pdf', '.docx'],
};
